import * as React from 'react';
import { PanelHeader } from 'js/components';
import { Card, CardBody, CardHeader, CardTitle } from 'reactstrap';

import { TeamForm } from 'js/components';

const TeamRouteComponent = ({ team, onSave }) => {
  const handleSave = (teamProps) => {
    onSave({ ...team, ...teamProps });
  };

  return (
    <div>
      <PanelHeader size="sm" />
      <div className="content">
        <Card>
          <CardHeader>
            <CardTitle tag="h5">{(team || {}).name}</CardTitle>
          </CardHeader>
          <CardBody>
            {team ? (
              <TeamForm team={team} onSave={handleSave} submitLabel="Update" />
            ) : null}
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default TeamRouteComponent;
